'use client'

/** Re-export so existing imports (`@/hooks/useFavoriteServices`) resolve to the shared context. */
export {
  useFavoriteServices,
  type FavoriteServicesContextValue,
} from '@/contexts/FavoriteServicesContext'
